
        (function () {
            let _activeType = null;
            let _retractTarget = 0, _retractProgress = 0;
            let _bladeData = null;
            const MAX_TILT = Math.PI / 2; // 90 deg

            function getScene() { return window.__pergolaScene || null; }

            function buildBladeData(stagger) {
                const scene = getScene();
                if (!scene) return false;

                const bioGroup = scene.getObjectByName('bioGroup');
                if (!bioGroup) { console.log('[RET] no bioGroup'); return false; }

                const EXCLUDED = new Set(['column', 'bioWall', 'dimLine', 'heightLine',
                    'circleDimZ', 'circleDimC', 'circleDimX', 'circleDimH',
                    'wallGroup', 'markersGroup', 'wallMarkerGroup',
                    'wall-left', 'wall-right', 'wall-back',
                    'leftMarker', 'rightMarker', 'bioGroup', 'Tmesh',
                    'houseGroup', 'leftWing', 'rightWing', 'houseWatermark', 'furnitureGroup',
                    'perimeterBeam']);

                const zBlades = [], xBlades = [];
                bioGroup.traverse(o => {
                    if (!o.isMesh || !o.geometry) return;
                    if (EXCLUDED.has(o.name)) return;
                    const nameStr = typeof o.name === 'string' ? o.name : '';
                    if (nameStr && (nameStr.startsWith('house') || nameStr.startsWith('furn') || nameStr.includes('Watermark') || nameStr.includes('Wing'))) return;
                    
                    // Check parents — skip if inside a wall/marker/house/furniture group
                    let p = o.parent;
                    let isExcluded = false;
                    while (p && p !== bioGroup) {
                        const pName = typeof p.name === 'string' ? p.name : '';
                        if (EXCLUDED.has(p.name) || (pName && (pName.startsWith('house') || pName.startsWith('furn') || pName.includes('Watermark') || pName.includes('Wing')))) {
                            isExcluded = true;
                            break;
                        }
                        p = p.parent;
                    }
                    if (isExcluded) return;
                    if (nameStr === 'persides') { zBlades.push(o); return; }
                    if (!nameStr) xBlades.push(o);
                });

                console.log('[RET] zBlades=', zBlades.length, 'xBlades=', xBlades.length);

                if (zBlades.length) {
                    // All axis:z blades share the same Z — group by X segment.
                    // Segment count mirrors the module: ceil(widthX/60) for widthZ<=40, ceil(widthX/40) otherwise.
                    // Each blade's openX ranges from -widthX/2 to +widthX/2.
                    // Find widthX from blade spread, compute segment boundaries.
                    zBlades.sort((a, b) => a.position.x - b.position.x);
                    const minX = zBlades[0].position.x;
                    const maxX = zBlades[zBlades.length - 1].position.x;
                    const widthX = (maxX - minX) + 1; // approximate
                    const S = Math.round(widthX / 60) || 1; // segment count
                    const segW = (maxX - minX + 1) / S;

                    // Group each blade into its segment by X position
                    const xSegs = Array.from({ length: S }, () => []);
                    zBlades.forEach(m => {
                        const si = Math.min(S - 1, Math.floor((m.position.x - minX) / segW));
                        xSegs[si].push(m);
                    });

                    _bladeData = [];
                    const STACK_SPACING_Z = 0.46; // Profile height ~0.43 -> 0.46 yields adjacent non-intersecting stacking
                    xSegs.forEach((seg, si) => {
                        if (!seg.length) return;
                        seg.sort((a, b) => a.position.x - b.position.x);
                        const n = seg.length;
                        const minX = seg[0].position.x;
                        const numMoving = n - 1;
                        const overlap = 0.30;
                        const bladeDuration = numMoving > 1 ? 1.0 / (1.0 + (numMoving - 1) * (1.0 - overlap)) : 1.0;
                        const step = bladeDuration * (1.0 - overlap);

                        seg.forEach((m, i) => {
                            const bladeStart = i === 0 ? 0 : (i - 1) * step;
                            const bladeEnd = i === 0 ? 0 : bladeStart + bladeDuration;
                            _bladeData.push({
                                mesh: m,
                                axis: 'z',
                                openX: m.position.x,
                                openZ: m.position.z,
                                stackX: minX + i * STACK_SPACING_Z,
                                tStart: bladeStart,
                                tEnd: bladeEnd,
                            });
                        });
                    });
                    console.log('[RET] built axis:z blades=', _bladeData.length, 'segs=', S);
                    window.__retBladeData = _bladeData;
                    return true;
                }

                if (xBlades.length) {
                    // Group blades by X segment (same position.x = same column bay)
                    const map = {};
                    xBlades.forEach(m => {
                        const key = m.position.x.toFixed(4);
                        if (!map[key]) map[key] = [];
                        map[key].push(m);
                    });

                    _bladeData = [];
                    const STACK_SPACING_X = 0.46;
                    const segs = Object.values(map).sort((a, b) => a[0].position.x - b[0].position.x);
                    const S = segs.length; // total number of X segments
                    segs.forEach((seg, si) => {
                        // Sort each segment by Z position (from house wall at minZ to front at maxZ)
                        seg.sort((a, b) => a.position.z - b.position.z);
                        const n = seg.length;
                        const minZ = seg[0].position.z;
                        const numMoving = n - 1;
                        const overlap = 0.30;
                        const bladeDuration = numMoving > 1 ? 1.0 / (1.0 + (numMoving - 1) * (1.0 - overlap)) : 1.0;
                        const step = bladeDuration * (1.0 - overlap);

                        seg.forEach((m, i) => {
                            const bladeStart = i === 0 ? 0 : (i - 1) * step;
                            const bladeEnd = i === 0 ? 0 : bladeStart + bladeDuration;
                            _bladeData.push({
                                mesh: m,
                                axis: 'x',
                                openX: m.position.x,
                                openZ: m.position.z,
                                stackZ: minZ + i * STACK_SPACING_X,
                                tStart: bladeStart,
                                tEnd: bladeEnd,
                            });
                        });
                    });
                    console.log('[RET] built axis:x blades=', _bladeData.length, 'segs=', Object.keys(map).length);
                    window.__retBladeData = _bladeData;
                    return true;
                }

                console.log('[RET] no blades found');
                return false;
            }

            function installRendererPatch() {
                const renderer = window.__pergolaRenderer;
                if (!renderer || renderer.__retPatchInstalled) return;
                renderer.__retPatchInstalled = true;
                const origRender = renderer.render.bind(renderer);
                renderer.render = function (scene, camera) {
                    if (_activeType) {
                        const isTilt = _activeType === 'tilt_retractable_pergko';
                        if (!_bladeData || !_bladeData.length || !_bladeData[0].mesh.parent) {
                            buildBladeData(isTilt);
                        }
                        if (_bladeData && _bladeData.length) {
                            const diff = _retractTarget - _retractProgress;
                            if (Math.abs(diff) < 0.001) _retractProgress = _retractTarget;
                            else _retractProgress += diff * 0.18;
                            window.__retBladeData = _bladeData;
                            window.__retState = { activeType: _activeType, target: _retractTarget, progress: _retractProgress, bladeCount: _bladeData.length };
                            
                            const TILT_MAX_90 = Math.PI / 2; // 90 deg for Tiltable & Retractable
                            const TILT_MAX_60 = (60 * Math.PI) / 180; // 60 deg for Retractable Only

                            for (const bd of _bladeData) {
                                let tiltAngle = 0;
                                let retractLocal = 0;

                                if (isTilt) {
                                    // Tiltable & Retractable Pergola: Phase 1 (0 to 0.25) tilts to 90 deg, Phase 2 (0.25 to 1.0) cascades/stacks one-by-one
                                    let tiltLocal = 0;
                                    if (_retractProgress <= 0.25) {
                                        tiltLocal = Math.min(1, _retractProgress / 0.25);
                                        retractLocal = 0;
                                    } else {
                                        tiltLocal = 1.0;
                                        const tRetract = (_retractProgress - 0.25) / 0.75;
                                        if (bd.tStart === bd.tEnd) {
                                            retractLocal = 1.0;
                                        } else {
                                            const u = Math.max(0, Math.min(1, (tRetract - bd.tStart) / (bd.tEnd - bd.tStart)));
                                            retractLocal = u * u * (3 - 2 * u);
                                        }
                                    }
                                    tiltAngle = tiltLocal * TILT_MAX_90;
                                } else {
                                    // Retractable Only Pergola: Tilt to 60 deg while stacking all together simultaneously when sliding
                                    const tiltLocal = _retractProgress;
                                    retractLocal = _retractProgress; // All blades slide together proportionally
                                    tiltAngle = tiltLocal * TILT_MAX_60;
                                }

                                if (bd.axis === 'z') {
                                    bd.mesh.rotation.z = tiltAngle;
                                    bd.mesh.position.x = bd.openX + (bd.stackX - bd.openX) * retractLocal;
                                } else {
                                    bd.mesh.rotation.x = tiltAngle;
                                    bd.mesh.position.z = bd.openZ + (bd.stackZ - bd.openZ) * retractLocal;
                                }
                            }
                        }
                    }
                    origRender(scene, camera);
                };
                console.log('[RET] renderer patched');
            }

            let _rebuildTimer = null;
            function scheduleRebuild() {
                if (!_activeType) return;
                clearTimeout(_rebuildTimer);
                _rebuildTimer = setTimeout(() => {
                    const isTilt = _activeType === 'tilt_retractable_pergko';
                    _bladeData = null;
                    buildBladeData(isTilt);
                    console.log('[RET] rebuilt, blades=', _bladeData ? _bladeData.length : 0);
                }, 300);
            }

            function applyUI(type) {
                document.querySelectorAll('.retractable-settings').forEach(el =>
                    el.style.display = type === 'retractable_pergko' ? '' : 'none');
                document.querySelectorAll('.tilt-retractable-settings').forEach(el =>
                    el.style.display = type === 'tilt_retractable_pergko' ? '' : 'none');
            }

            function resetBlades() {
                if (!_bladeData) return;
                _bladeData.forEach(bd => {
                    if (bd.axis === 'z') { bd.mesh.position.x = bd.openX; bd.mesh.rotation.z = 0; }
                    else { bd.mesh.position.z = bd.openZ; bd.mesh.rotation.x = 0; }
                });
                _bladeData = null;
            }

            function initSliders() {
                ['persidesRotation_retractable', 'persidesRotation_tilt_retractable'].forEach(id => {
                    const s = document.getElementById(id);
                    if (!s) return;
                    s.addEventListener('input', function () {
                        _retractTarget = parseFloat(this.value) / 100;
                        if (!_bladeData) buildBladeData(id.includes('tilt'));
                        installRendererPatch();
                    });
                });

                document.addEventListener('sliderValuesChanged', e => {
                    if (!_activeType || !e.detail) return;
                    const s = e.detail.slider;
                    if (s === 'widthX' || s === 'widthZ' || s === 'columnHeight') scheduleRebuild();
                });
            }

            function onTypeChange(val) {
                applyUI(val);
                const isRetractable = val === 'retractable_pergko';
                const isTilt = val === 'tilt_retractable_pergko';

                if (isRetractable || isTilt) {
                    resetBlades();
                    _activeType = val;
                    _retractTarget = 0; _retractProgress = 0;
                    const sid = isTilt ? 'persidesRotation_tilt_retractable' : 'persidesRotation_retractable';
                    const s = document.getElementById(sid);
                    if (s) s.value = 0;

                    const poll = setInterval(() => {
                        if (window.__pergolaScene) {
                            clearInterval(poll);
                            buildBladeData(isTilt);
                            installRendererPatch();
                        }
                    }, 100);
                } else {
                    resetBlades();
                    _activeType = null;
                }
            }

            function init() {
                document.querySelectorAll('input[name="pergolaType"]').forEach(r => {
                    r.addEventListener('change', function () {
                        if (this.checked) onTypeChange(this.value);
                    });
                });
                const checked = document.querySelector('input[name="pergolaType"]:checked');
                if (checked) onTypeChange(checked.value);
                initSliders();
            }

            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
            else init();
        })();
    